import React from 'react';
import { CreditCard, Clock } from 'lucide-react';

const PaymentModeSelector = ({
  paymentMode,
  onChangeMode,
  fullAmount,
  installmentData,
}) => {
  if (!installmentData) {
    return null;
  }

  return (
    <div
      className="network-card p-8"
      data-testid="checkout-payment-mode-selector"
    >
      <h3 className="text-xl font-bold text-white mb-4">Payment Mode</h3>

      <div className="space-y-3">
        <label className="flex items-start gap-3 p-4 rounded-lg border border-white/10 cursor-pointer hover:border-brand-primary transition-colors">
          <input
            type="radio"
            name="paymentMode"
            value="full"
            checked={paymentMode === 'full'}
            onChange={(e) => onChangeMode(e.target.value)}
            className="mt-1"
            data-testid="checkout-payment-mode-full"
          />
          <div className="flex-1">
            <div className="flex items-center gap-2 text-white font-semibold">
              <CreditCard size={18} className="text-brand-primary" aria-hidden="true" />
              <span>Pay Full Amount</span>
            </div>
            <p className="text-text-secondary text-sm mt-1">
              ₹{fullAmount.toLocaleString('en-IN')}
            </p>
          </div>
        </label>

        <label className="flex items-start gap-3 p-4 rounded-lg border border-white/10 cursor-pointer hover:border-brand-primary transition-colors">
          <input
            type="radio"
            name="paymentMode"
            value="installment"
            checked={paymentMode === 'installment'}
            onChange={(e) => onChangeMode(e.target.value)}
            className="mt-1"
            data-testid="checkout-payment-mode-installment"
          />
          <div className="flex-1">
            <div className="flex items-center gap-2 text-white font-semibold">
              <Clock size={18} className="text-brand-accent" aria-hidden="true" />
              <span>Pay in 2 Installments</span>
            </div>
            <p className="text-text-secondary text-sm mt-1">
              ₹{installmentData.installment_1.toLocaleString('en-IN')} now + ₹
              {installmentData.installment_2.toLocaleString('en-IN')} later
            </p>
          </div>
        </label>
      </div>

      {paymentMode === 'installment' && (
        <div
          className="mt-4 p-4 rounded-lg bg-brand-primary/10 border border-brand-primary/30"
          data-testid="checkout-installment-note"
        >
          <p className="text-sm text-text-secondary">
            <strong className="text-brand-primary">Note:</strong> You'll pay the
            first installment now (₹
            {installmentData.installment_1.toLocaleString('en-IN')}). We'll
            contact you for the second installment payment.
          </p>
        </div>
      )}
    </div>
  );
};

export default PaymentModeSelector;
